import { Link } from "wouter";
import { Calculator, ArrowRight } from "lucide-react";

interface CalculatorCTAProps {
  className?: string;
}

export function CalculatorCTA({ className = "" }: CalculatorCTAProps) {
  return (
    <section className={`py-12 px-4 bg-muted ${className}`}>
      <div className="container mx-auto max-w-3xl">
        <div className="flex flex-col sm:flex-row items-center gap-6 bg-background border border-border rounded-lg p-6 md:p-8 shadow-sm text-center sm:text-left">
          <div className="shrink-0 bg-primary/10 text-primary rounded-full p-4">
            <Calculator className="h-8 w-8" />
          </div>
          <div className="flex-1">
            <h2 className="text-xl md:text-2xl font-serif font-bold text-foreground mb-1">
              Estimate Your Project in Seconds
            </h2>
            <p className="text-muted-foreground">
              Get a ballpark price range for your roofing or siding project before you call.
            </p>
          </div>
          <Link
            href="/roofing-siding-cost-calculator-lancaster-pa/"
            className="shrink-0 inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded font-bold hover:bg-primary/90 transition-colors shadow-md whitespace-nowrap"
            data-testid="link-cost-calculator"
          >
            Try the Cost Calculator <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
